import * as React from "react";
import { useFormContext } from "react-hook-form";
import { AutoComplete } from "components";
import { GetPage, StoredBreed, dbQueries } from "duck";
import { SpeciesEnum } from "requests";
import { Types as FormTypes } from "../../duck";

const Breed: React.FC = () => {
  const { watch, setValue } = useFormContext<FormTypes.FormValues>();
  const species = watch("species");

  const getPage: GetPage<StoredBreed> = React.useCallback(
    (_, variables) => dbQueries.loadBreeds({ ...variables, species }),
    [species]
  );

  return (
    <AutoComplete<StoredBreed>
      name="breed"
      label="Breed"
      placeholder="Breed"
      creatable
      optionValue="name"
      isDisabled={
        species !== null &&
        species !== SpeciesEnum.Cat &&
        species !== SpeciesEnum.Dog
      }
      getPage={getPage}
      onChange={(value, opt) => {
        setValue("breed", value, { shouldValidate: true });
        if (opt && !species) {
          setValue("species", opt.species || null, { shouldValidate: true });
        }
      }}
    />
  );
};

export default Breed;
